import React, { createContext, useContext, useEffect, useState } from "react";
import { API } from "./api";

const AuthCtx = createContext({ user: null, setUser: () => {}, logout: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    API.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);
  const logout = async () => {
    try {
      await API.post("/auth/logout");
    } catch {
      /* ignore */
    }
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export const isManagerUp = (user) => ["shop_owner", "shop_manager"].includes(user?.role);
export const isOwnerRole = (user) => user?.role === "shop_owner";

export function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="loading-screen">
      <div className="h-10 w-10 rounded-full border-4 border-emerald-600 border-t-transparent animate-spin" />
    </div>
  );
}
